<div
  class="password-form mx-auto d-flex align-items-md-center justify-content-start pt-0 pt-md-3 pb-5 px-3 px-md-5">
  <div class="form-container w-100">
    <div class="logo-header d-flex align-items-center my-md-4">
      <img
        src="assets/images/logo_legatus_fundo_claro_1.png"
        alt="Legatus Growth Partner"
        title="Legatus Growth Partner"
        class="img-fluid" />
    </div>
    <div class="password-form__header my-3">
      <h2 class="password-form__header__title my-4">
        <span class="color__dark cursor-pointer me-3" (click)="handleFormMode('login')">
          <fa-icon [icon]="faArrowLeftLong" size="xs"></fa-icon>
        </span>
        {{ tk.Auth.RecoverPasswordTitle | t }}
      </h2>
      <p class="password-form__header__subtitle mb-4">
        {{ tk.Auth.RecoverPasswordInstructions | t }}
      </p>
    </div>
    <div class="form-body">
      <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()" appAutoFormGroup>
        <div class="form-group">
          <app-input
            id="passwordFormemail"
            type="email"
            [placeholder]="tk.General.Insert | t"
            [controlName]="props.email"
            [label]="tk.Auth.FieldEmail | t"
            [required]="true"
            [error]="true"></app-input>
        </div>
        <div class="form-group">
          <app-button
            [disabled]="isLoading"
            [type]="'submit'"
            [id]="'submit'"
            [label]="tk.General.Send | t"
            [disabled]="isEmailInvalidOrEmpty()"></app-button>
        </div>
      </form>
    </div>
  </div>
</div>
